module.exports = __webpack_public_path__ + "static/media/youmetal-logo.68ae1d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/youmetal-logo.png
// module id = 299
// module chunks = 0